/* ===========================================================
   Rodapé ÚNICO do site — usado pela landing e pelas páginas de conteúdo.
   Colunas: Marca (+ glyphs de integração) · Produto (âncoras da landing) ·
   Recursos (Blog, Guia, Calculadoras) · Empresa.

   Âncoras de seção (#problema…): na home usam "#x" (scroll suave); fora dela
   usam "/#x" (navega para a home e o browser rola até a âncora no load).
   =========================================================== */
import { Link, useLocation } from "react-router-dom";
import { Logo, IntegrationGlyph } from "./ui.jsx";

const INTEGRACOES = ["nuvemshop", "meta", "ga", "gads"];

const SECOES: ReadonlyArray<{ hash: string; rotulo: string }> = [
  { hash: "problema", rotulo: "ROAS + lucro" },
  { hash: "meu-lucro", rotulo: "Módulos" },
  { hash: "comecar", rotulo: "Comece agora" },
  { hash: "faq", rotulo: "FAQ" },
];

export function SiteFooter() {
  const naHome = useLocation().pathname === "/";
  const ancora = (h: string) => (naHome ? `#${h}` : `/#${h}`);

  return (
    <footer style={{ borderTop: "1px solid rgba(255, 255, 255, 0.08)", background: "transparent" }}>
      <div className="lp-wrap">
        <div className="lp-footer">
          <div>
            <Link to="/" aria-label="Página inicial do Lucraa+">
              <Logo size={28} color="#fff" />
            </Link>
            <p
              style={{
                fontSize: 13.5,
                color: "var(--ink-soft)",
                lineHeight: 1.55,
                margin: "14px 0 16px",
                maxWidth: 280,
              }}
            >
              ROAS real + lucro das vendas para lojistas Nuvemshop que investem em tráfego pago.
            </p>
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              {INTEGRACOES.map((k) => (
                <IntegrationGlyph key={k} kind={k} size={26} />
              ))}
            </div>
          </div>

          <nav aria-label="Produto">
            <h3 className="lp-footer-title">Produto</h3>
            <ul>
              {SECOES.map((s) => (
                <li key={s.hash}>
                  <a href={ancora(s.hash)}>{s.rotulo}</a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Recursos">
            <h3 className="lp-footer-title">Recursos</h3>
            <ul>
              <li>
                <Link to="/blog">Blog</Link>
              </li>
              <li>
                <Link to="/lucro-real-ecommerce">Guia do lucro real</Link>
              </li>
              <li>
                <Link to="/calculadora/roas-de-equilibrio">Calculadora de ROAS</Link>
              </li>
              <li>
                <Link to="/calculadora/margem-de-contribuicao">Calculadora de margem</Link>
              </li>
            </ul>
          </nav>

          <nav aria-label="Empresa">
            <h3 className="lp-footer-title">Empresa</h3>
            <ul>
              <li>
                <Link to="/termos">Termos de Uso</Link>
              </li>
              <li>
                <Link to="/privacidade">Política de Privacidade</Link>
              </li>
              <li>
                <a href="mailto:contato@digitalizee.com.br">contato@digitalizee.com.br</a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="lp-footer-legal">
          <span>© 2026 Lucraa · ROAS real + lucro das vendas para lojistas Nuvemshop</span>
          <span>Um produto Digitalizee</span>
        </div>
      </div>
    </footer>
  );
}
